module.exports = __webpack_public_path__ + "img/ypost.8a2b316a.png";